import React, { Component } from 'react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { observer } from 'mobx-react';
import { IFieldData } from '../../component-level-fields/component-field';

interface IProps { 
    selectedTemplateName: string, 
    updateViewSourceComponentConfig: Function, 
    fieldInfo: IFieldData 
}

class GridComponentName extends Component<IProps, any>{
    public render() {
        const { name, inputParamKey } = this.props.fieldInfo;
        const componentName = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, inputParamKey);
        
        return (
            <div className="slds-form-element">
                <label className="slds-form-element__label">{name}</label>
                <div className="slds-form-element__control">
                    <input type="text" placeholder="Placeholder Text" disabled={true} className="slds-input" value={componentName} />
                </div>
            </div>
        );
    }

}

export const GridComponentCompName = observer(GridComponentName);